import { render, staticRenderFns } from "./AppDown.vue?vue&type=template&id=4ed093ec&scoped=true&"
import script from "./AppDown.vue?vue&type=script&lang=js&"
export * from "./AppDown.vue?vue&type=script&lang=js&"
import style0 from "./AppDown.vue?vue&type=style&index=0&id=4ed093ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed093ec",
  null
  
)

export default component.exports